import type {
  BehaviorHeartbeatData,
  HeartbeatActivityState,
  HeartbeatConfig,
} from '../contracts/heartbeat';

export class HeartbeatSnapshotBuilder {
  constructor(private readonly config: HeartbeatConfig) {}

  build(
    state: HeartbeatActivityState,
    sequence: number,
    now: number = Date.now()
  ): BehaviorHeartbeatData {
    const idle = state.idle === true;
    const visible = state.visible !== false;
    const active = !idle && visible;

    const base: BehaviorHeartbeatData = {
      sequence,
      active,
      idle,
      visible,
      elapsedMs: Math.max(0, now - state.startedAt),
    };

    if (!this.config.includeSnapshot) {
      return base;
    }

    return {
      ...base,
      ...(state.lastActivityAt !== undefined
        ? { lastActivityAt: state.lastActivityAt }
        : {}),
      ...(state.idleSince !== undefined ? { idleSince: state.idleSince } : {}),
      ...(state.visibleSince !== undefined
        ? { visibleSince: state.visibleSince }
        : {}),
      ...(state.hiddenSince !== undefined
        ? { hiddenSince: state.hiddenSince }
        : {}),
    };
  }
}
